export default __webpack_public_path__ + "static/media/origin-place.dfaed5b3.svg";